import { render, staticRenderFns } from "./RedeemHistory.vue?vue&type=template&id=2a82ec65&scoped=true&"
import script from "./RedeemHistory.vue?vue&type=script&lang=js&"
export * from "./RedeemHistory.vue?vue&type=script&lang=js&"
import style0 from "./RedeemHistory.vue?vue&type=style&index=0&id=2a82ec65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a82ec65",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
